export default "__VITE_ASSET__031a56eb__"